import { css } from 'lit';
export const styles = css `:host{--value-label: var(--ig-rating-value-label, hsla(var(--ig-gray-700), var(--ig-gray-a)))}`;
